import React from "react";

class MeetMighty extends React.Component {
    render() {
        const clearStyle = {
            clear: "both"
        };
        const PaddingStyle = {
            paddingLeft: "5%"
        };

        const sectionStyle = {
            background: "#fff",
            padding: "0"
        };

        const strongStyle = {
            fontSize: "1.2em",
            color: "#0076be"
        };
        return (
            <section className="section" style={sectionStyle}>
                <div className="container">
                    <div className="row">

                        <div className="col-md-5">
                            <div className="lowpriceImg">
                                <img src="/images/110618-003.jpg" alt="" className=""/>
                            </div>
                        </div>

                        <div className="col-md-7">
                            <h1 className="">MEET THE MIGHTY</h1>
                            <h3 className="">
                                The best way to stay connected on
                                <br />
                                the go with powerful wifi
                            </h3>
                            <div className="row">
                                <div className="col-12 col-md-3">
                                    <strong style={strongStyle}>AS LOW AS</strong>
                                    <div className="">$3</div>
                                </div>
                                <div className="col-12 col-md-9">
                                    <div className="">
                                        Connect Up To 10 Devices
                                        <br />
                                        Unlimited Data
                                        <br />
                                        No Contract
                                    </div>
                                </div>
                                <div style={clearStyle} />
                                <div className="col-12">
                                    <div className="notice">
                                        {/** After data cap per day, speed limited to Maximum of 128kbps.*/}
                                        * 1 GB per day data cap.
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        );
    }
}

export default MeetMighty;



// WEBPACK FOOTER //
// ./src/layout/MeetMighty.js